<script lang="ts">
	import { cn } from '$lib/utils/style';
	import { getTimeAgoText } from '$lib/utils/time';

	const locale = 'it';

	export let tooltip: 'tooltip-top' | 'tooltip-right' | 'tooltip-bottom' | 'tooltip-left' =
		'tooltip-top';
	export let date: Date;
	export let options: Intl.DateTimeFormatOptions = {
		dateStyle: 'long',
	};

	$: formatted = new Intl.DateTimeFormat(locale, options).format(date);

	let className = '';
	export { className as class };
</script>

<time
	datetime={date.toISOString()}
	class={cn('tooltip', tooltip, 'cursor-help underline decoration-dotted', className)}
	data-tip={formatted}
>
	{getTimeAgoText(date)}
</time>
